import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-loan-settlement-negotiation-reject-pop-up',
  templateUrl: './loan-settlement-negotiation-reject-pop-up.component.html',
  styleUrls: ['./loan-settlement-negotiation-reject-pop-up.component.css']
})
export class LoanSettlementNegotiationRejectPopUpComponent implements OnInit {

  private readonly dialogRef: MatDialogRef<LoanSettlementNegotiationRejectPopUpComponent>;

  constructor(
    dialogRef: MatDialogRef<LoanSettlementNegotiationRejectPopUpComponent>) {
    this.dialogRef = dialogRef;
  }

  ngOnInit(): void {
  }

  decline(): void {
    this.dialogRef.close();
  }

}
